import { Logo } from '~/components/ui';
import { cn } from '~/lib/utils';

export const BrandBackground = (props: { class?: string }) => {
  return (
    <div
      class={cn('absolute inset-0 flex justify-center items-center overflow-hidden', props.class)}
    >
      <div class="size-[80vh] aspect-square blur-sm text-primary opacity-10">
        <Logo />
      </div>
    </div>
  );
};
